import { Host, h } from '@stencil/core';
export class AibaNavigationBlock {
  constructor() {
    this.handlers = undefined;
    this.data = undefined;
    this._id = undefined;
    this.styles = undefined;
    this.successStatus = false;
  }
  componentWillLoad() {
    var _a, _b, _c;
    if (this.handlers && ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.navigationBlockOnLoad)) {
      this.handlers && ((_b = this.handlers) === null || _b === void 0 ? void 0 : _b.navigationBlockOnLoad) && ((_c = this.handlers) === null || _c === void 0 ? void 0 : _c.navigationBlockOnLoad());
    }
  }
  render() {
    var _a, _b, _c, _d, _e, _f;
    if (typeof this.data === 'string' || typeof this.handlers === 'string') {
      if (this.data)
        this.data = JSON.parse(this === null || this === void 0 ? void 0 : this.data);
      if (this.handlers)
        this.handlers = JSON.parse(this === null || this === void 0 ? void 0 : this.handlers);
    }
    return (h(Host, { id: this._id ? this._id : '' }, this.styles && h("style", null, this.styles), this.successStatus ? (h("div", { class: "newsletter-container successStatus", id: this.data._id ? this.data._id : '' }, (_d = (_c = (_b = (_a = this.data) === null || _a === void 0 ? void 0 : _a.successState) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.elements) === null || _d === void 0 ? void 0 : _d.map((element) => {
      return h("div", { class: "newsletter-container-label-wrapper" }, (element === null || element === void 0 ? void 0 : element.name) === 'aiba-label' && h("aiba-label", Object.assign({}, element['data'])));
    }))) : (h("div", { class: "navigation-block-wrapper" }, this.data &&
      ((_f = (_e = this.data) === null || _e === void 0 ? void 0 : _e.elements) === null || _f === void 0 ? void 0 : _f.map((component) => {
        var _a, _b;
        if (component && component['name'] === 'aiba-image') {
          return h("img", { src: (_a = component === null || component === void 0 ? void 0 : component.data) === null || _a === void 0 ? void 0 : _a.src, alt: (_b = component === null || component === void 0 ? void 0 : component.data) === null || _b === void 0 ? void 0 : _b.altText });
        }
        if (component && component['name'] === 'aiba-label')
          return h("aiba-label", Object.assign({}, component['data']));
        if (component && component['name'] === 'aiba-pdf-button')
          return (h("aiba-button", Object.assign({}, component['data'], { handleClick: async (event) => {
              var _a, _b;
              const response = (await this.handlers) && (await ((_a = this.handlers) === null || _a === void 0 ? void 0 : _a.emailPDF)) && (await ((_b = this.handlers) === null || _b === void 0 ? void 0 : _b.emailPDF(event)));
              if (response) {
                this.successStatus = true;
              }
            } })));
        if (component && component['name'] === 'aiba-button')
          return (h("aiba-button", Object.assign({}, component['data'], { handleClick: (event) => this.handlers && this.handlers.handleNavigationBlockButtonClick(event, component['data']['handlerName']) })));
      }))))));
  }
  static get is() { return "aiba-navigation-block"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-navigation-block.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-navigation-block.css"]
    };
  }
  static get properties() {
    return {
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "_id": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "_id",
        "reflect": false
      },
      "styles": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "styles",
        "reflect": false
      }
    };
  }
  static get states() {
    return {
      "successStatus": {}
    };
  }
}
//# sourceMappingURL=aiba-navigation-block.js.map
